import React from "react";

import HomeHero from "./HomeHero";

import HomeContent from "./HomeContent";


function Home() {
  return (
    <>
    <HomeHero />
    <HomeContent />
    </>
  );
}

export default Home;
